import { useEffect, useRef, useState } from "react";
import "./TogglesContenido.css";

//   //options ----------------------------------------------
//   planoTipoAreasExactas: true, //Opcional default false
//   combinarPdfs: false, //Opcional default false
//   //docs -------------------------------------------------
//   planoTipo: true, //Opcional
//   especificaciones: true, //Opcional
//   memoria: true, //Opcional
//   // acabados: true, //Opcional

function TogglesContenido({ contenidoRef, hasAreasExactas }) {
  const [contenido, setContenido] = useState({ planoTipo: true });
  const showToggles = useRef(contenidoRef.current);

  const updateContenido = (key, value) => {
    setContenido({ ...contenido, [key]: value });
  };

  useEffect(() => {
    contenidoRef.current = contenido;
  }, [contenido, contenidoRef]);

  //   console.log("contenidoRef", contenidoRef.current);
  //   console.log("showToggles", showToggles);

  if (!contenidoRef.current && !hasAreasExactas) return null;

  return (
    <>
      {/*Opciones ------------------------------------------------*/}
      <div className="toggles-contenido-container">
        {hasAreasExactas && (
          <label htmlFor="planoTipoAreasExactas">
            <input
              type="checkbox"
              id="planoTipoAreasExactas"
              checked={contenido?.planoTipoAreasExactas}
              onChange={(e) =>
                updateContenido("planoTipoAreasExactas", e.target.checked)
              }
            />
            Areas exactas
          </label>
        )}

        {showToggles.current && (
          <label htmlFor="combinarPdfs">
            <input
              type="checkbox"
              id="combinarPdfs"
              checked={contenido?.combinarPdfs}
              onChange={(e) =>
                updateContenido("combinarPdfs", e.target.checked)
              }
            />
            Combinar PDFs
          </label>
        )}
      </div>

      {/*Docs ----------------------------------------------------*/}
      {showToggles.current && (
        <>
          <div className="toggles-contenido-container">
            <label htmlFor="planoTipo">
              <input
                type="checkbox"
                id="planoTipo"
                checked={contenido?.planoTipo}
                onChange={(e) => updateContenido("planoTipo", e.target.checked)}
              />
              Plano Tipo
            </label>

            <label htmlFor="especificaciones">
              <input
                type="checkbox"
                id="especificaciones"
                checked={contenido?.especificaciones}
                onChange={(e) =>
                  updateContenido("especificaciones", e.target.checked)
                }
              />
              Especificaciones
            </label>

            <label htmlFor="memoria">
              <input
                type="checkbox"
                id="memoria"
                checked={contenido?.memoria}
                onChange={(e) => updateContenido("memoria", e.target.checked)}
              />
              Memoria
            </label>

            {/* <input
          type="checkbox"
          id="Acabados"
          checked={contenido?.Acabados}
          onChange={(e) => updateContenido("Acabados", e.target.checked)}
        />
        <label htmlFor="Acabados">Acabados</label> */}
          </div>
        </>
      )}
    </>
  );
}

export default TogglesContenido;
